import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 280,
      flexShrink: 0,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: COLORS.neutral.secondary,
      overflowY: 'hidden',
    },
    logoWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: theme.spacing(2, 2, 1),
    },
    logo: {},
    createContentItem: {},
    scrollable: {
      flexGrow: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      padding: theme.spacing(0, 2),
      scrollbarColor: `${COLORS.gray.gray60} transparent`,
      display: 'flex',
      flexDirection: 'column',
    },
    homeItem: {},
    folderItems: {
      marginTop: theme.spacing(0.5),
    },
    divider: {
      borderBottom: theme.shape.borderDarkGray,
      margin: theme.spacing(2, -2, 3),
    },
    sidebarItems: {},
    trialProgress: {
      margin: theme.spacing('auto', -0.5, 1),
    },
    workspaceItem: {
      borderTop: theme.shape.borderDarkGray,
      flexShrink: 0,
    },
  }),
  { name: 'NavigationSidebarPanel' }
);
